<script setup>
defineProps({
  heading: { type: String, required: true },
  links: { type: Array, default: () => [] },
});
</script>

<template>
  <div class="flex flex-col gap-[10px] self-stretch flex-1">
    <div class="font-base font-helvetica-bold h-[29px]">{{ heading }}</div>
    <div class="flex flex-col gap-5 self-stretch">
      <BlokLink
        v-for="link in links"
        :key="link._uid"
        :blok="link.url"
        :is-form="link.isForm"
      >
        {{ link.text }}
      </BlokLink>
    </div>
  </div>
</template>
